export default {"src":"/_next/static/media/american-football.2a8a79f6.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};